// extracted by mini-css-extract-plugin
export default {"products":"Products_products__sDAEq","productsList":"Products_productsList__-IQJI","productsListItem":"Products_productsListItem__bAazK"};